import "./Tooltip.scss";
import template from "lodash/template";
import { motion } from "framer-motion";
export function Tooltip({
	getBasePosition,
	data,
	prefix,
	format,
	contentTemplate = "<%=value%>",
}) {
	let basePosition = getBasePosition();
	let left = data.position.left - basePosition.left;
	let top = data.position.top - basePosition.top;
	return (
		<motion.div
			className={"line-graph-tooltip"}
			initial={{ opacity: 0, transform: "translateY(20px)" }}
			animate={{ opacity: 1, transform: "translateY(0px)" }}
			exit={{ opacity: 0, transform: "translateY(-20px)" }}
			transition={{ type: "tween" }}
			style={{ top: top - 19, left: left }}>
			<motion.div className={"line-graph-tooltip__container"}>
				{data.data.title}
				<br />
				{template(contentTemplate)({
					value: prefix + (format ? format(data.data.value) : data.data.value),
				})}
			</motion.div>
		</motion.div>
	);
}
